export const ProductManagedServices = (): JSX.Element => (
  <h1>Managed Services</h1>
);
